import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children", "sx", "external"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { ExternalLink, LanguageSelector, Link, UnavailableInLens } from '@infl-ts/ui-advocate-components';
import { logout } from '@infl-ts/util-hub-axios-instance';
import { mergeSxProps } from '@infl-ts/util-merge-sx-props';
import { Logout as LogoutIcon } from '@mui/icons-material';
import { Box, Divider, ListItemIcon, ListItemText, MenuItem, Typography } from '@mui/material';
import { forwardRef } from 'react';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export var MenuLink = /*#__PURE__*/forwardRef(function MenuLink(_ref, ref) {
  var children = _ref.children,
      sx = _ref.sx,
      external = _ref.external,
      rest = _objectWithoutProperties(_ref, _excluded);

  var menuLinkSx = mergeSxProps({
    color: function color(t) {
      return t.palette.text.primary;
    },
    fontWeight: function fontWeight(t) {
      return t.typography.fontWeightMedium;
    },
    '&:hover': {
      textDecoration: 'none'
    }
  }, sx);
  return external ? /*#__PURE__*/_jsx(ExternalLink, _objectSpread(_objectSpread(_objectSpread({
    ref: ref,
    sx: menuLinkSx
  }, rest.target === '_blank' ? {
    rel: 'noopener noreferrer'
  } : undefined), rest), {}, {
    children: children
  })) : /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({
    ref: ref,
    sx: menuLinkSx
  }, rest), {}, {
    children: children
  }));
});
export var AccountMenuLinks = function AccountMenuLinks(_ref2) {
  var handlePopoverClose = _ref2.handlePopoverClose,
      privacyPolicyLink = _ref2.privacyPolicyLink,
      termsAndConditionsLink = _ref2.termsAndConditionsLink,
      memberMessagingEnabled = _ref2.memberMessagingEnabled,
      actionBarLangSelectorEnabled = _ref2.actionBarLangSelectorEnabled;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [memberMessagingEnabled ? /*#__PURE__*/_jsx(UnavailableInLens, {
      tooltip: true,
      children: /*#__PURE__*/_jsx(Box, {
        onClick: handlePopoverClose,
        children: /*#__PURE__*/_jsx(MenuLink, {
          tabIndex: 0,
          href: "/chat?p=admin",
          children: /*#__PURE__*/_jsx(MenuItem, {
            children: /*#__PURE__*/_jsx(Translation, {
              children: function children(t) {
                return /*#__PURE__*/_jsx(ListItemText, {
                  primary: /*#__PURE__*/_jsx(Typography, {
                    component: "span",
                    children: t('Message Admin')
                  })
                });
              }
            })
          })
        })
      })
    }) : null, termsAndConditionsLink ? /*#__PURE__*/_jsx(Box, {
      onClick: handlePopoverClose,
      children: /*#__PURE__*/_jsx(MenuLink, {
        tabIndex: 0,
        href: termsAndConditionsLink,
        target: termsAndConditionsLink.startsWith('/') ? undefined : '_blank',
        children: /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return /*#__PURE__*/_jsx(ListItemText, {
                primary: /*#__PURE__*/_jsx(Typography, {
                  component: "span",
                  children: t('Terms and Conditions')
                })
              });
            }
          })
        })
      })
    }) : null, privacyPolicyLink ? /*#__PURE__*/_jsx(Box, {
      onClick: handlePopoverClose,
      children: /*#__PURE__*/_jsx(MenuLink, {
        tabIndex: 0,
        href: privacyPolicyLink,
        target: privacyPolicyLink.startsWith('/') ? undefined : '_blank',
        children: /*#__PURE__*/_jsx(MenuItem, {
          children: /*#__PURE__*/_jsx(Translation, {
            children: function children(t) {
              return /*#__PURE__*/_jsx(ListItemText, {
                primary: /*#__PURE__*/_jsx(Typography, {
                  component: "span",
                  children: t('Privacy Policy')
                })
              });
            }
          })
        })
      })
    }) : null, actionBarLangSelectorEnabled ? /*#__PURE__*/_jsx(LanguageSelector, {
      containerSx: {
        mx: 2,
        mt: 1
      },
      reloadOnLanguageChange: true
    }) : null, /*#__PURE__*/_jsx(Divider, {
      sx: {
        my: 1
      },
      "data-element": "Divider",
      "data-component": "AccountMenuLinks",
      "data-source-file": "account-menu-links.tsx"
    }), /*#__PURE__*/_jsxs(MenuItem, {
      onClick: function onClick() {
        logout();
        handlePopoverClose();
      },
      sx: {
        color: function color(t) {
          return t.palette.text.primary;
        },
        fontWeight: function fontWeight(t) {
          return t.typography.fontWeightMedium;
        }
      },
      "data-element": "MenuItem",
      "data-source-file": "account-menu-links.tsx",
      children: [/*#__PURE__*/_jsx(ListItemIcon, {
        "data-element": "ListItemIcon",
        "data-source-file": "account-menu-links.tsx",
        children: /*#__PURE__*/_jsx(LogoutIcon, {
          "data-element": "LogoutIcon",
          "data-source-file": "account-menu-links.tsx"
        })
      }), /*#__PURE__*/_jsx(Translation, {
        "data-element": "Translation",
        "data-source-file": "account-menu-links.tsx",
        children: function children(t) {
          return /*#__PURE__*/_jsx(ListItemText, {
            tabIndex: 0,
            primary: /*#__PURE__*/_jsx(Typography, {
              component: "span",
              children: t('Sign Out')
            })
          });
        }
      })]
    })]
  });
};